import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getDashboardPaymentCollection = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/payment-collection',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getDashboardPaymentOrderRefund = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/refund/order-refund',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getDashboardPaymentOrderRefundItem = (id) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/refund/order-refund/' + id,
    headers: getHeaders(),
  });
};